import {ReactElement} from 'react'
import {Grid} from '@material-ui/core'
import {Trans} from 'react-i18next'
import messages from '../../../../../../../assets/messages'
import NotificationBar from '../../../../../../Common/NotificationBar'
import {EmptyTableResults} from '../../../../../../Common/EmptyTableResults'

type ErrorLayoutProps = {
  scope: 'table' | 'stats'
}

export const ErrorLayout = (props: ErrorLayoutProps): ReactElement => {
  const {scope} = props

  return (
    <Grid item xs={12}>
      <NotificationBar status="info">
        {scope === 'table' ? <Trans {...messages.noFollowersDataAvailable} /> : <Trans {...messages.generalError} />}
      </NotificationBar>
      {scope === 'table' ? <EmptyTableResults/> : null}
    </Grid>
  )
}
